export default "__VITE_ASSET__1K$3apJF__"